export function preserveNull(target: any) {
  if (target) {
    if (Array.isArray(target)) {
      let index = target.length;
      while (index--) {
        if (typeof target[index] === 'object') {
          target[index] = preserveNull(target[index]);
        }
      }
    } else if (typeof target === 'object') {
      const keys = Object.keys(target);
      let keysIndex = keys.length;
      while (keysIndex--) {
        const key = keys[keysIndex];
        if (Array.isArray(target[key])) {
          preserveNull(target[key]);
        } else if (typeof target[key] === 'object') {
          target[key] = preserveNull(target[key]);
        } else if (target[key] === undefined) {
          target[key] = null;
        }
      }
    }
    return target;
  }
}
